module.exports = __webpack_public_path__ + "static/media/iconSearchHover.2ed88ff9.svg";